import React from 'react';
import { Link } from 'react-router-dom';
export function CTASection() {
  return <section className="w-full bg-[#0F0F0F] py-24 px-4" data-id="element-22">
      <div className="max-w-4xl mx-auto text-center space-y-8" data-id="element-23">
        <h2 className="text-3xl md:text-[2.75rem] font-medium tracking-tight text-white leading-[1.1]" data-id="element-24">
          See how AI talks about your brand
        </h2>

        <p className="text-lg md:text-xl text-[#9B9B9B] leading-relaxed max-w-2xl mx-auto" data-id="element-25">
          Book a demo. Send us your prompts. We will chat using your data.
        </p>

        <div className="pt-4" data-id="element-26">
          <Link to="/contact" className="inline-flex items-center px-8 py-4 text-lg font-medium text-[#0F0F0F] bg-white hover:bg-[#FAF9F7] rounded-full transition-all duration-200 hover:-translate-y-0.5" data-id="element-27">
            Book a Demo
          </Link>
        </div>
      </div>
    </section>;
}